import { render, staticRenderFns } from "./teams.vue?vue&type=template&id=54ba1bac&scoped=true"
import script from "./teams.vue?vue&type=script&lang=js"
export * from "./teams.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ba1bac",
  null
  
)

export default component.exports